import { InfoOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

interface StoneXHelpLabelProps {
  label: ReactNode;
  helpText: ReactNode;
  helpLabel?: string;
}

export function StoneXHelpLabel(props: StoneXHelpLabelProps) {
  const helpLabel = props.helpLabel ?? `Help for ${String(props.label)}`;

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '16px' }}>
      <span>{props.label}</span>
      <Tooltip title={props.helpText} placement="top" arrow>
        <Box
          component="span"
          role="img"
          tabIndex={0}
          aria-label={helpLabel}
          sx={{ display: 'inline-flex', color: 'var(--gray4)', cursor: 'help' }}
        >
          <InfoOutlined sx={{ fontSize: 18 }} />
        </Box>
      </Tooltip>
    </Box>
  );
}